<template>
  <div class="passenger-form-row">
    <div class="passenger-item-title">
      <h3>旅客</h3>
      <span v-if="specialType==='MWD'">残疾军人</span>
      <span v-if="specialType==='PWD'">伤残人民警察</span>
    </div>
    <div class="passenger-item-content">
      <div class="passenger-wrap clearfix">
        <div class="field-outter">
          <a-form-item label="姓名" required>
            <a-input
              v-decorator="[
                `passengers[0].fullName`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
              size="large"
              placeholder="请输入姓名"
              :disabled="airline === 'JD'"
            />
          </a-form-item>
        </div>
        <div class="field-outter">
          <a-form-item label="证件类型" required>
            <a-select
              placeholder="请选择证件类型"
              size="large"
              v-decorator="[
                `passengers[0].idType`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
            >
              <a-select-option v-for="(value, key) in orderCertificateDomesticMap" :value="key" :key="key">{{ value }}</a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="field-outter field-long">
          <a-form-item label="证件号码" required>
            <a-input
              v-decorator="[
                `passengers[0].certificateNo`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
              size="large"
              placeholder="请输入证件号码"
            />
          </a-form-item>
        </div>
        <div class="field-outter field-long">
          <a-form-item label="军残证号码" v-if="specialType==='MWD'" required>
            <a-input
              v-decorator="[
              `passengers[0].specialCertificateNo`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
              size="large"
              placeholder="请输入军残证号码"
            />
          </a-form-item>
          <a-form-item label="警残证号码" v-if="specialType==='PWD'" required>
            <a-input
              v-decorator="[
                `passengers[0].specialCertificateNo`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
              size="large"
              placeholder="请输入警残证号码"
            />
          </a-form-item>
        </div>
        <div class="field-outter field-long contact-mobile">
          <a-form-item label="手机号码" required>
            <a-input
              v-decorator="[
                `passengers[0].mobile`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
              size="large"
              placeholder="请输入手机号码"
            >
              <a-select
                class="counrty-code-select"
                showSearch
                slot="addonBefore"
                :dropdownMatchSelectWidth="false"
                :filterOption="countryCodefilter"
                :options="countryCodeList"
                optionLabelProp="value"
                v-decorator="[
                  `passengers[0].areaCode`,
                  { initialValue: '86' }
                ]"
              >
              </a-select>
            </a-input>
          </a-form-item>
          <a-form-item label="类型" class="hidden">
            <a-input
              v-decorator="[
                `passengers[0].birthday`
              ]"
              size="large"
              hidden
            />
          </a-form-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { orderCertificateDomesticMap } from '@/dicts/order'

const airline = window.__MICRO_ROOT__?.airline
export default {
  name: 'specialPassenger',
  props: {
    specialType: { type: String }
  },
  data () {
    return {
      countryCodeList: [],
      airline,
      orderCertificateDomesticMap
    }
  },
  mounted () {
    // 异步加载，代码分离
    require.ensure([], (require) => {
      this.countryCodeList = require('@/assets/js/countrycode').default
    })
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      this.$emit('inputItemValide', rule.fullField, value, callback)
    },
    countryCodefilter (input, option) {
      return option.data?.attrs?.data.toLowerCase().indexOf(input) >= 0
    }
  }
}
</script>
<style lang="less">
@import "formStyle";
</style>
